<div class="login-container">
  <div fxLayout="row" *ngIf="minorSavings">
    <b
      >Please check your inbox associated with your account for your online
      banking credentials.</b
    >
  </div>

  <div fxLayout="column" fxLayoutAlign="center center">
    <ng-container *ngIf="isInJointMaintenanceFlow; else isInRegularFlow">
      <h3 class="account-created">You have been successfully added!</h3>
    </ng-container>
    <ng-template #isInRegularFlow>
      <h3 class="account-created">Your account has been created!</h3>
    </ng-template>
    <p class="create-login">
      Please create your login to view and access your account within online
      banking.
    </p>
  </div>

  <form class="mt-30" [formGroup]="loginInfoForm" *ngIf="!minorSavings">
    <div
      fxLayout="row"
      class="username-message"
      *ngIf="applicationHasSecondaryApplicant"
    >
      Username and password creation is only for primary applicant.
    </div>
    <div
      fxLayout="row"
      fxLayout.xs="column"
      [fxLayoutGap.gt-xs]="'100px'"
      [fxLayoutAlign.gt-xs]="'center start'"
    >
      <div fxLayout="column" [fxFlex.gt-sm]="'20'">
        <div>
          <mat-label-tooltip for="username" id="username-label"
            >* Username</mat-label-tooltip
          >
          <div>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="username"
                formControlName="username"
                placeholder="Username"
                aria-describedby="usernameAlphaErr usernameMinMaxCharErr usernameMaxCharErr usernameReqiredErr usernameUnavailableErr usernameAvailable"
                [ngClass]="usernameClass"
              />
            </mat-form-field>
          </div>
        </div>
        <div>
          <mat-label><h4>Username criteria</h4></mat-label>
          <div>
            <app-validation-message
              id="usernameAlphaErr"
              *ngIf="loginInfoForm.controls['username'].hasError('pattern')"
              [hasError]="
                loginInfoForm.controls['username'].hasError('pattern')
              "
            >
              Username must include only alphanumeric characters
            </app-validation-message>

            <app-validation-message
              id="usernameMinMaxCharErr"
              *ngIf="loginInfoForm.controls['username'].hasError('minlength')"
              [hasError]="
                loginInfoForm.controls['username'].hasError('minlength')
              "
            >
              Username should be between {{ usernameMin }} and
              {{ usernameMax }} characters
            </app-validation-message>

            <app-validation-message
              id="usernameMaxCharErr"
              *ngIf="loginInfoForm.controls['username'].hasError('maxlength')"
              [hasError]="
                loginInfoForm.controls['username'].hasError('maxlength')
              "
            >
              Username should be between {{ usernameMin }} and
              {{ usernameMax }} characters
            </app-validation-message>

            <app-validation-message
              id="usernameReqiredErr"
              *ngIf="loginInfoForm.controls['username'].hasError('required')"
              [hasError]="
                loginInfoForm.controls['username'].hasError('required')
              "
            >
              Username is required
            </app-validation-message>
            <app-validation-message
              id="usernameUnavailableErr"
              *ngIf="loginInfoForm.controls['username'].hasError('userExists')"
              [hasError]="
                loginInfoForm.controls['username'].hasError('userExists')
              "
            >
              Username is unavailable
            </app-validation-message>
            <app-validation-message
              id="usernameAvailable"
              *ngIf="
                (showUsernameAvailableMessage | async) &&
                loginInfoForm.controls['username'].valid
              "
              [hasError]="false"
            >
              Username is available
            </app-validation-message>
          </div>
        </div>
      </div>
      <mat-divider *ngIf="isMobile$ | async"></mat-divider>
      <div id="accent-line" *ngIf="!(isMobile$ | async)"></div>
      <div fxLayout="column" [fxFlex.gt-sm]="'20'">
        <div>
          <mat-label-tooltip for="password" id="password-label"
            >* Password</mat-label-tooltip
          >
          <mat-form-field appearance="outline">
            <input
              matInput
              id="password"
              formControlName="password"
              type="password"
              placeholder="Password"
              autocomplete="false"
              [type]="hidePassword ? 'password' : 'text'"
              [ngClass]="passwordClass"
              aria-describedby="passowrdRequired"
            />
            <button
              mat-icon-button
              matSuffix
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="!hidePassword"
            >
              <mat-icon
                class="click-icon"
                id="passwordVisibility"
                (click)="hidePassword = !hidePassword"
                >{{ hidePassword ? "visibility_off" : "visibility" }}</mat-icon
              >
            </button>
          </mat-form-field>
          <div
            class="is-invalid"
            role="alert"
            *ngIf="
              loginInfoForm.controls['password'].hasError('required') &&
              loginInfoForm.controls['password'].dirty
            "
          >
            <label id="passowrdRequired" class="text-danger">
              Password is Required
            </label>
          </div>
        </div>

        <div>
          <mat-label-tooltip for="confirmPassword" id="confirm-password-label"
            >* Re-Enter Password</mat-label-tooltip
          >
          <div>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="confirmPassword"
                formControlName="confirmPassword"
                type="password"
                placeholder="Password"
                autocomplete="false"
                [type]="hideConfirmPassword ? 'password' : 'text'"
                [ngClass]="passwordClass"
                aria-describedby="hasPasswordMatch hasMinLength hasSpecialChars hasSmallChar hasNumbers hasPasswordMatch"
              />
              <button
                mat-icon-button
                matSuffix
                [attr.aria-label]="'Hide password confirm'"
                [attr.aria-pressed]="!hideConfirmPassword"
              >
                <mat-icon
                  class="click-icon"
                  id="confirmPasswordVisibility"
                  (click)="hideConfirmPassword = !hideConfirmPassword"
                  >{{
                    hideConfirmPassword ? "visibility_off" : "visibility"
                  }}</mat-icon
                >
              </button>
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row" fxLayout.xs="column" class="justify-content-end">
          <div fxFlex.sm="100" [fxFlex.xs]="'100'" fxFlex>
            <mat-label><h4>Password criteria</h4></mat-label>
            <div>
              <app-validation-message
                id="hasMinLength"
                [hasError]="passwordHasError('minlength')"
              >
                Minimum {{ passwordPolicy?.minPasswordLength }} characters
              </app-validation-message>
              <app-validation-message
                id="hasSpecialChars"
                *ngIf="passwordPolicy?.specialCharRequired"
                [hasError]="passwordHasError('hasSpecialCharacters')"
              >
                One Special Character
              </app-validation-message>
              <app-validation-message
                id="hasCapitalChars"
                *ngIf="passwordPolicy?.upperCaseRequired"
                [hasError]="passwordHasError('hasCapitalCase')"
              >
                At least 1 uppercase character
              </app-validation-message>
              <app-validation-message
                id="hasSmallChar"
                *ngIf="passwordPolicy?.lowerCaseRequired"
                [hasError]="passwordHasError('hasSmallCase')"
              >
                At least 1 lowercase character
              </app-validation-message>
              <app-validation-message
                id="hasNumbers"
                *ngIf="passwordPolicy?.numbersRequired"
                [hasError]="passwordHasError('hasNumber')"
              >
                At least 1 number
              </app-validation-message>
              <app-validation-message
                id="hasPasswordMatch"
                [hasError]="confirmPasswordHasError('NoPassswordMatch')"
              >
                Passwords match
              </app-validation-message>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
